<template>
  <div>
    <h3>Warranty Policy</h3>
    <!-- Warranty Policy Content -->
    <div class="pt-5">
      <h3>Warranty Policy Content</h3>
      <!-- 保固服務內容 -->
      <div class="form-item py-5 d-flex">
        <div class="w-180px mr-5">
          <h4>保固服務內容</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <button
            class="button btn ml-auto w-117px justify-space-between"
            @click="$router.push({
              name: 'G-1-1b-3-1__SupportEdit_B2C_WarrantyPolicy_ContentEdit',
              params: {
                id: $route.params.id,
              },
            })"
          >
            <span>前往編輯</span>
            <v-icon>arrow_forward</v-icon>
          </button>
        </div>
      </div>
    </div>
    <!-- Warranty Check -->
    <div class="pt-5">
      <h3>Warranty Check</h3>
      <div class="py-5">可自行添加</div>
      <!-- itemList -->
      <PageCollapse v-for="(item, i) in support.warranty_policy.checks" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Warranty Check {{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- Basic section -->
          <div>
            <!-- Type -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-180px mr-5">Type</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-text-field
                  v-model="item.title"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Description -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-180px mr-5">Description</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-text-field
                  v-model="item.description"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Example for Serial No. -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-180px mr-5">Example for Serial No.</h4>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-text-field
                  v-model="item.example_no"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- img upload -->
            <div class="d-flex px-5 pt-5 mb-8">
              <div class="w-180px">
                <h4 class="mb-10px">Image</h4>
                <div class="h5 ink-02-medium--text">
                  建議尺寸：999px * 999px <br />
                  檔案大小限制：&lt; 1 MB
                </div>
              </div>
              <div class="d-flex justify-end flex-grow-1">
                <ImgUploader
                  :imageUrl.sync="item.image"
                  :dir="'support'"></ImgUploader>
              </div>
            </div>
          </div>
        </template>
      </PageCollapse>
      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        type: '',
        description: '',
        categoryVisual: '',
        image: null,
      };
      this.support.warranty_policy.checks.push(template);
    },
    deleteItem(item) {
      const index = this.support.warranty_policy.checks.map((option) => option.id).indexOf(item.id);
      this.support.warranty_policy.checks.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.warranty_policy.checks.length - 1) {
        this.support.warranty_policy.checks.splice(i, 1);
        this.support.warranty_policy.checks.unshift(item);
        return;
      }
      // item become next index
      this.support.warranty_policy.checks.splice(i, 1);
      this.support.warranty_policy.checks.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.warranty_policy.checks.splice(i, 1);
        this.support.warranty_policy.checks.push(item);
        return;
      }
      // item become previous index
      this.support.warranty_policy.checks.splice(i, 1);
      this.support.warranty_policy.checks.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
